import { render, staticRenderFns } from "./brandResource.vue?vue&type=template&id=13942fb2&"
import script from "./brandResource.vue?vue&type=script&lang=js&"
export * from "./brandResource.vue?vue&type=script&lang=js&"
import style0 from "./brandResource.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports